import React, { useContext, useLayoutEffect, useState } from "react";

export type UnassignedStopNestExpandValue = {
  open: boolean;
  version: number;
};

export const UnassignedStopNestExpandContext = React.createContext<UnassignedStopNestExpandValue>({
  open: false,
  version: 0,
});

/** Syncs nested unassigned stop collapsibles with Expand All / Collapse All in the Unassigned column. */
export function useUnassignedStopNestExpandSync(): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const { open: parentOpen, version } = useContext(UnassignedStopNestExpandContext);
  const [open, setOpen] = useState(false);

  useLayoutEffect(() => {
    setOpen(parentOpen);
  }, [version, parentOpen]);

  return [open, setOpen];
}
